import React, { useEffect, useState } from "react";
import { Heart, CheckCircle2, Ribbon } from "lucide-react";
import { api } from "@/lib/api";
import { Loading, PageHead, Empty } from "@/components/common";

export default function Following() {
  const [sellers, setSellers] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => { api.get("/following").then((d) => setSellers(d.sellers)).catch(() => {}).finally(() => setLoading(false)); }, []);

  if (loading) return <Loading />;

  return (
    <div className="fade-up">
      <PageHead title="Following" sub="Sellers you follow — get notified when they go live." />
      {sellers.length === 0 ? (
        <Empty icon={Heart} title="You're not following anyone yet" sub="Follow sellers from their live shows to see them here." />
      ) : (
        <div className="ss-grid grid-3" data-testid="following-grid">
          {sellers.map((s) => (
            <div className="ss-card" style={{ padding: 20, textAlign: "center" }} key={s.user_id}>
              <img src={s.avatar} alt={s.name} style={{ width: 72, height: 72, borderRadius: 999, objectFit: "cover", margin: "0 auto", border: "2px solid var(--gold)" }} />
              <div style={{ fontWeight: 800, marginTop: 12, display: "flex", justifyContent: "center", alignItems: "center", gap: 6 }}>
                {s.name}
                {s.verified && <CheckCircle2 size={15} className="badge-verified" />}
                {s.founding && <Ribbon size={14} style={{ color: "var(--gold)" }} />}
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
